// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header.PageHeader {
  display: flex;
  gap: 2rem;
  width: calc(100% + 8rem);
  margin-left: -4rem;
  padding: 1rem 4rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
header.PageHeader .PageHeader-Back,
header.PageHeader .PageHeader-Icon,
header.PageHeader .PageHeader-Info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
header.PageHeader .PageHeader-Back .btn {
  display: flex;
  gap: 0.5rem;
}
header.PageHeader .PageHeader-Content {
  flex-grow: 1;
  margin-left: -1.5rem;
}
header.PageHeader .PageHeader-Icon {
  width: 4rem;
  height: 4rem;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  border-radius: 0.75rem;
  transform: scale(0.75);
  background: var(--bs-primary);
  color: #fff;
}
header.PageHeader .PageHeader-Subtitle,
header.PageHeader .PageHeader-Info {
  color: rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/PageHeader/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2CAAA;AACF;AAAE;;;EAGE,aAAA;EACA,sBAAA;EACA,uBAAA;AAEJ;AACI;EACE,aAAA;EACA,WAAA;AACN;AAEE;EACE,YAAA;EACA,oBAAA;AAAJ;AAEE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,WAAA;AAAJ;AAEE;;EAEE,yBAAA;AAAJ","sourcesContent":["header.PageHeader {\n  display: flex;\n  gap: 2rem;\n  width: calc(100% + 8rem);\n  margin-left: -4rem;\n  padding: 1rem 4rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  .PageHeader-Back,\n  .PageHeader-Icon,\n  .PageHeader-Info {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n  .PageHeader-Back {\n    .btn {\n      display: flex;\n      gap: 0.5rem;\n    }\n  }\n  .PageHeader-Content {\n    flex-grow: 1;\n    margin-left: -1.5rem;\n  }\n  .PageHeader-Icon {\n    width: 4rem;\n    height: 4rem;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n    border-radius: 0.75rem;\n    transform: scale(0.75);\n    background: var(--bs-primary);\n    color: #fff;\n  }\n  .PageHeader-Subtitle,\n  .PageHeader-Info {\n    color: rgba(0, 0, 0, 0.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
